import {Component, ContentChild, HostBinding, Input, ChangeDetectionStrategy} from '@angular/core';
import {DecimalInputDirective} from '../decimal-input.directive';

const WITH_CURRENCY_CLASS = '-with-currency';

@Component({
    selector: 'decimal-input-wrapper',
    templateUrl: './decimal-input-wrapper.component.html',
    styleUrls: ['./decimal-input-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DecimalInputWrapperComponent {

    @Input()
    @HostBinding(`class.${WITH_CURRENCY_CLASS}`)
    public currency: string;

    @ContentChild(DecimalInputDirective, {static: false})
    public decimalInput: DecimalInputDirective;

    public stepUp(): void {
        this.decimalInput.stepUp();
    }

    public stepDown(): void {
        this.decimalInput.stepDown();
    }
}
